import { Injectable } from '@angular/core';

/**
 * Zeigt serverseitig gerenderte Diagramme im Chatverlauf an (`RAGAI.CHARTS`).
 * @remarks
 * Aktuell nur ein Diagrammtyp implementiert ({@link radar}). Das Diagramm wird nicht clientseitig gezeichnet,
 * sondern als Bild von `/api/chart/radar` geladen und via `RAGAI.imageCard` in den Chatverlauf eingefügt -
 * technisch also eine `RAGAI.CARDS.image()`-Card mit generierter Bild-URL, keine eigene Card-Art.
 */
@Injectable({ providedIn: 'root' })
export class ChartService {
  /**
   * Zeigt ein Radar-Diagramm (Netzdiagramm) als Bild-Card im Chatverlauf an.
   * @param data Werte je Achse.
   * @param labels Achsenbeschriftungen (Standard: A, B, C, ...).
   * @param color Linien-/Füllfarbe des Diagramms.
   * @param options Zusätzliche Darstellungsoptionen, z.B. eine CSS-Klasse für die Card.
   */
  public radar(data: number[], labels?: string[], color?: string, options?: { cssClass: string }) {
    // generate a DUMMY Labels ARRAY, A,B,C,...
    const dummyLables = data.map((_, index) => String.fromCharCode(65 + index));
    const dummyColor = color ?? '#c0c0c0';
    if (labels) {
      labels.forEach((label, index) => {
        dummyLables[index] = label;
      });
    }

    const chartData = {};
    data.forEach((value, index) => {
      //@ts-expect-error
      chartData[dummyLables[index]] = value;
    });

    let className = "";
    if (options?.cssClass) {
      className = options.cssClass;
    }

    void window.RAGAI.imageCard('/api/chart/radar?' + window.RAGAI.qs.stringify({
      data: [
        chartData
      ],
      features: dummyLables,
      colors: [dummyColor]
    }), "Ein Chart", className);
  }
}